import { useEffect, useRef, useState } from 'react'

function useSnooze() {
  const [isSnoozed, setIsSnoozed] = useState(false)
  const timerRef = useRef<NodeJS.Timeout | null>(undefined)

  function snooze(timeOutInMs: number) {
    if (timerRef.current) {
      clearTimeout(timerRef.current)
    }

    setIsSnoozed(true)

    if (timeOutInMs === Infinity) return

    timerRef.current = setTimeout(() => {
      setIsSnoozed(false)
    }, timeOutInMs)
  }

  useEffect(() => {
    return () => {
      if (!timerRef.current) return
      clearTimeout(timerRef.current)
    }
  }, [])

  return {
    isSnoozed,
    snooze,
  }
}

export default useSnooze